import { AppHelper } from "../appHelper.js"
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp.js";
import { Helper } from "../core/util/helper.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { Grid } from "../core/components/grid.js";
import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar.js";
import { Config } from "../core/config/config.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { SearchHelper } from "../core/util/searchfieldHelper.js";
import { Dialog, DialogAction, DialogProps } from "../core/components/dialog.js";
import { General } from "../../siteManagement/general.js";
import {
    AssignmentGroupingView,
    ResourcePlanningSchedulerSettingsViewModel
} from "../resourcePlanningScheduler/resourcePlanningScheduler.js";
import GridOptions = kendo.ui.GridOptions;
import { ModalDialogProps } from "../../siteManagement/showmodal.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import React from "react";


export class ResourcePlaningGroupingHelper {

    public static checkCopyGrouped = async (projNr: string, pIndex: number, resourceId: string,
        grouping: number, newResourceIds: string[]) => {

        //no grouping
        if (grouping <= 0)
            return false;

        //resource-assignment
        if (resourceId.startsWith("r|")) {
            //remove own resourceId
            if (newResourceIds.filter(r => r != resourceId).length == 0)
                return false;
        }

        if (resourceId.startsWith("g")) {
            //container can be copied to resource
            if (newResourceIds.filter(r => r.startsWith("r|")).length == 0)
                return false;
        }


        const check = await HTTPService
            .post<JsonResultClass<AssignmentGroupingView[]>>("ResourcePlanning/CheckCopyAssignmentRessGr", {
                projNr: projNr, pIndex: pIndex
            });

        if (check.Code != 0 || check.Data.length == 0)
            return false;

        const question = Helper.getTranslation("WebSMS.ResourcePlaningGrouping.CopyGrouppedToRessource");
        const selectedAss = Helper.getTranslation("WebSMS.ResourcePlaningGrouping.SelectedAssignment");
        const groupedAss = Helper.getTranslation("WebSMS.ResourcePlaningGrouping.GrouppedAssignments");
        const all = Helper.getTranslation("WebSMS.ResourcePlaningGrouping.SelectedAll");
        const only = Helper.getTranslation("WebSMS.ResourcePlaningGrouping.SelecterdOnly");

        const msg = question + "<br>" +
            selectedAss + ": " + projNr + "-" + pIndex + "<br>" +
            groupedAss + ": " + check.Data.map(a => a.projNr + "-" + a.pIndex).join(", ");

        return await DialogHelper.confirm(msg, null, only, all, true);
    }

    public static updateAssigmentGroupList(assignmentList: Array<{ ProjNr: string, PIndex: number }>,
        gruppierung: number = 0,
        silent: boolean = false,
        onRefresh: any = null) {

        if (assignmentList && assignmentList.length > 0) {
            HTTPService.post<JsonResultClass>("ResourcePlanning/UpdateAssigmentGrouping",
                { "assignments": assignmentList, "gruppierung": gruppierung })
                .then(result => {
                    if (result.Code !== 0) {
                        if (!silent)
                            NotificationHelper.showErrorMessage(result.Message);
                    } else
                        if (onRefresh) {
                            onRefresh();
                        }
                });
        }
    }

    public static updateAssigmentGroup(projNr: string, pIndex: number, gruppierung: number = 0, silent: boolean = false, onRefresh: any = null) {
        const assignmentList: Array<{ ProjNr: string, PIndex: number }> = Array(
            { "ProjNr": projNr, "PIndex": pIndex });

        this.updateAssigmentGroupList(assignmentList, gruppierung, silent, onRefresh)
    }

    // noinspection JSUnusedGlobalSymbols
    public static checkAssignmentGroup = (projNr: string, pIndex: number): Promise<number> => {
        return new Promise<number>((resolve) => {
            HTTPService.post<JsonResultClass>("ResourcePlanning/GetAssignmentGroupingCount", {
                projNr: projNr,
                pIndex: pIndex,

            }).then((result: JsonResultClass) => {
                if (result.Code === 0) {
                    resolve(result.Data)
                } else
                    resolve(0);
            }, (error) => {
                console.error(error);
                resolve(0);
            });
        });
    }

    // noinspection JSUnusedGlobalSymbols
    public static getNewAssignmentGroup = (): Promise<number> => {
        return new Promise<number>((resolve) => {
            HTTPService.get<JsonResultClass>("ResourcePlanning/GetNewGroupingId",).then((result: JsonResultClass) => {
                resolve(result.Data)
            }, (error) => {
                console.error(error);
                resolve(0);
            });
        });
    }
}

export class ResourcePlanningGroupingApp extends React.Component<ResourcePlanningGroupingProps, any> {
    common = new AppHelper();
    setTabTitle = true;
    private _assigmentsData: Array<any> = [];
    protected _assigmentGridRef: Grid;
    assigmentGridOptions: kendo.ui.GridOptions;

    constructor(props: ResourcePlanningGroupingProps) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);

        this._refresh(true).then();
    }

    private _refresh = async (updateState: boolean = false) => {
        const result = await HTTPService.get("ResourcePlanning/GetAssignmentsByGrouping",
            {
                projNr: this.props.entity.projNr,
                pIndex: this.props.entity.pIndex,
                grouping: this.props.entity.grouping
            });
        Helper.setArrayValues(this._assigmentsData, result.Data);
        if (updateState)
            this.setState({});
    }

    handleFieldChange = (field: any, value: any, dataItem = null, isInit = false) => {
        switch (field.model) {
            default:
                break;
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    private _addNewGrouping = () => {
        let url = "DynamicSearch/Window/AssignmentGrouping?fullObject=true&cus_ignored=true";

        const componentHelper = ComponentHelper.createFactory();
        const componentSearchProps = componentHelper.getDefaultSearchFieldProps();
        componentSearchProps.field.searchWindowUrl = url;

        const that = this;
        new SearchHelper().openSearch(
            componentSearchProps,
            null,
            (_field: any, object: any) => {
                ResourcePlaningGroupingHelper.updateAssigmentGroup(
                    object.projnr,
                    object.pindex,
                    this.props.entity.grouping,
                    false,
                    () => { that._refresh(true).then(); }
                );
            },
            () => this.setState({ searchOpened: true }));
    }

    private _handleClickassigmentGridButton = (type: ToolBarStandardButtonType, dataItem: any) => {
        switch (type) {
            case ToolBarStandardButtonType.RELOAD: {
                this._refresh(true).then();
                break;
            }
            case ToolBarStandardButtonType.NEW: {
                this._addNewGrouping();
                break;
            }
            case ToolBarStandardButtonType.DELETE: {
                ResourcePlaningGroupingHelper.updateAssigmentGroup(dataItem.ProjNr, dataItem.PIndex, 0, false, () => { this._refresh(true).then() });
                break;
            }
        }
    }

    // noinspection JSUnusedGlobalSymbols
    createGrid = () => {
        let assigmentGridButtons: Array<ToolBarStandardButton> = [];

        assigmentGridButtons.push({ type: ToolBarStandardButtonType.RELOAD, caption: Config.translations.reloadLabel, enabled: true });
        assigmentGridButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
        assigmentGridButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.delete, enabled: true });

        return (
            <div className="flex-container">

                <Grid data={this._assigmentsData} options={this.assigmentGridOptions} id="assigmentGrid" ref={(r) => this._assigmentGridRef = r}
                    standardButtons={assigmentGridButtons} onClickStandardButton={this._handleClickassigmentGridButton}
                />
            </div>
        );
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

export interface ResourcePlanningGroupingDialogProps extends ModalDialogProps {
    projNr: string,
    pIndex: number;
    resizeAction: boolean;
    groupings: Array<number>,
    settings: ResourcePlanningSchedulerSettingsViewModel,
    //translations,
    mainAssignmentLockId: number,
    onGetDataBack: (data: any[]) => void,
    oldRess: string,
    newRess: string,
    newStart: Date | string,
    newEnd: Date | string,
    byDelta: boolean,
    assignmentsNoGrouping: Array<AssignmentGroupingView>;
}

export class ResourcePlanningGroupingDialog extends React.Component<ResourcePlanningGroupingDialogProps, { dataLoaded: boolean }> {
    private _assigmentsGridRef: Grid;
    private _assigmentsGridOptions: GridOptions;
    private _assigmentsData: Array<any> = [];
    protected entity: any;
    private IsGuids = [];
    // private translations: [];

    private asyncReleaseLocks = async (data: any[]) => {
        //console.log("ResourcePlanningGroupingDialog::asyncReleaseLock: " + data);
        await HTTPService.post<JsonResultClass>("ResourcePlanningScheduler/ReleaseLockedAssignments", { lockIds: data });
    }

    private forceReleaseLocks = () => {
        const locks = [];
        if (this.props.mainAssignmentLockId != null)
            locks.push(this.props.mainAssignmentLockId);

        const items = this._assigmentsData;
        for (let i = 0; i < items.length; i++) {
            if (items[i].IsId > 0) {
                locks.push(items[i].IsId);
            }
        }

        const headers = {
            type: 'application/json',
        };

        const blob = new Blob([JSON.stringify(locks)], headers);
        navigator.sendBeacon(Config.baseUrl + "ResourcePlanningScheduler/ReleaseLockedAssignments", blob);
    }

    private removeLocks = () => {
        const locks = [];
        if (this.props.mainAssignmentLockId != null)
            locks.push(this.props.mainAssignmentLockId);

        const items = this._assigmentsData;
        for (let i = 0; i < items.length; i++) {
            if (/*this.IsGuids.indexOf(items[i].IsGuid) > -1 && */items[i].IsId > 0) {
                locks.push(items[i].IsId);
            }
        }
        this.asyncReleaseLocks(locks).then();
    }

    private GetAssignmentGroupingDialogActions = (): Array<DialogAction> => {
        return [
            {
                label: Config.translations.cancel,
                action: () => {
                    this.removeLocks();
                    this.props.onCancel();
                },
                cancel: true
            },
            {
                label: Config.translations.apply,
                action: () => {
                    if (this.props.onGetDataBack) {
                        const items = this._assigmentsData;
                        const moveInstances = [];
                        for (let i = 0; i < items.length; i++) {
                            if (this.IsGuids.indexOf(items[i].IsGuid) > -1) {
                                const newStartIst = items[i].NewStartIst;
                                const newEndeIst = items[i].NewEndeIst;

                                const oldResourceId = items[i].RessNr != "" ? "r|" + items[i].RessNr : "g|" + items[i].GrNr;

                                const newResourceId = items[i].NewRessNr != "" ? "r|" + items[i].NewRessNr : "g|" + items[i].NewGrNr;

                                if (oldResourceId != newResourceId || items[i].NewStartIst != items[i].StartIst || items[i].NewEndeIst != items[i].EndeIst) {
                                    moveInstances.push({
                                        projNr: items[i].ProjNr, pIndex: items[i].PIndex, newStart: newStartIst, newEnd: newEndeIst,
                                        newResourceId: newResourceId, oldResourceId: oldResourceId, resizeAction: items[i].ResizeAction, byDelta: this.props.byDelta, slot: null, lockId: items[i].IsId
                                    });
                                }
                            }
                        }

                        this.props.onGetDataBack(moveInstances);
                        this.removeLocks();
                        this.props.onOk();
                    }
                    else {
                        this.removeLocks();
                        this.props.onCancel();
                    }


                },
                primary: true

            }];
    }

    constructor(props: ResourcePlanningGroupingDialogProps) {
        super(props)
        this.entity = {};

        General.Sheet.Manager.getTopMostSheet().setUpUnloadHelper().addBeforeUnloadCallback(this.forceReleaseLocks);

        this.state = {
            dataLoaded: null
        };
    }

    async componentDidMount() {
        let res = await Promise.all([
            Helper.getMetaData("resourcePlanningGrouping"),
            HTTPService.post<JsonResultClass<EinsatzViewModelWithGruppirungStatus[]>>("ResourcePlanning/GetAssignmentsByGroupingOrSelection",
                {
                    projNr: this.props.projNr, pIndex: this.props.pIndex,
                    newStart: Helper.dates.getISODateString(this.props.newStart), newEnd: Helper.dates.getISODateString(this.props.newEnd), resizeAction: this.props.resizeAction, byDelta: this.props.byDelta === true,
                    timeResolutionType: this.props.settings != null ? this.props.settings.TimeResolutionType : null,
                    showAssignmentsWithTimeZones: this.props.settings != null ? this.props.settings.ShowAssignmentsWithTimeZones : false,
                    oldRessNr: this.props.oldRess, newRessNr: this.props.newRess,
                    groupings: this.props.groupings, assignmentsNoGrouping: this.props.assignmentsNoGrouping, doLock: true
                })
        ]);

        if (res != null) {
            Helper.setArrayValues(this._assigmentsData, res[1].Data);

            const now = new Date();

            this._assigmentsData.forEach(item => {
                if (!item.Unselect && item.Recht == true &&
                    item.Belege != true &&
                    item.Datensatzsperre != true &&
                    !item.Fixiert &&
                    item.ActionLock == true &&
                    (item.ChangedH || item.ChangedV) &&
                    item.ResizeFehler != true &&
                    Helper.dates.compareMultiTypeDates(item.StartIst, now, true) > 0) {
                    item.Selected = true;
                    this.IsGuids.push(item.IsGuid);
                }
            });

            this._assigmentsGridOptions = res[0].additional.objects.find(x => x.name == "assigmentGridOptions").data;

            if (this._assigmentsGridOptions.columns) {
                this._assigmentsGridOptions.columns.find(x => x.field == "Selected").hidden = false;
                this._assigmentsGridOptions.columns.find(x => x.field == "NewStartIst").hidden = false;
                this._assigmentsGridOptions.columns.find(x => x.field == "NewEndeIst").hidden = false;
                this._assigmentsGridOptions.columns.find(x => x.field == "NewGruppeName").hidden = false;
                this._assigmentsGridOptions.columns.find(x => x.field == "NewRessName").hidden = false;
                this._assigmentsGridOptions.columns.find(x => x.field == "NewRessNr").hidden = false;
                this._assigmentsGridOptions.columns.find(x => x.field == "ResizeFehler").hidden =
                    !this.props.resizeAction;
            }

            const hasSelectable = this._assigmentsData.filter(x =>
                x.Recht == true &&
                x.Datensatzsperre != true &&
                x.Fixiert != true &&
                x.ActionLock == true &&
                (x.ChangedV || x.ChangedH) /* &&
                x.Belege != true &&
                x.ResizeFehler != true*/).length > 0;

            if (!hasSelectable) {
                this.GetAssignmentGroupingDialogActions()[1].action();
                return null;
            }

            this.setState({ dataLoaded: true });
        }
    }

    componentDidUpdate() {
        const header = document.querySelector("#ResourcePlanningGroupingDialogGrid .k-grid-header");
        if (header)
            (header as any).style.flex = "none";

    }

    // noinspection JSUnusedGlobalSymbols
    customGridFunction = (params: any) => {
        return <a onClick={() => { /*this.props.onSave(params.Isguid) */ }}>{params.FileName}</a>
    }


    private onCustomButtonClick = (id: string) => {
        if (id == "selectAll") {
            const selected = $("input[type=checkbox]:not(:checked)", this._assigmentsGridRef.getGridRef().element[0]);
            if (selected != null && selected.length > 0) {
                for (let i = 0; i < selected.length; i++) {
                    if (!(selected[i] as HTMLInputElement).disabled && !(selected[i] as HTMLInputElement).checked) {
                        selected[i].click();
                    }
                }
            }
        }

        if (id == "unSelectAll") {
            const selected = $("input[type=checkbox]:checked", this._assigmentsGridRef.getGridRef().element[0]);
            if (selected != null && selected.length > 0) {
                for (let i = 0; i < selected.length; i++) {
                    if (!(selected[i] as HTMLInputElement).disabled && (selected[i] as HTMLInputElement).checked) {
                        selected[i].click();
                    }
                }
            }
        }

        if (id == "selectSameResourceOrGroup") {
            const selected = $("input[type=checkbox]:not(:checked)", this._assigmentsGridRef.getGridRef().element[0]);
            if (selected != null && selected.length > 0) {
                for (let i = 0; i < selected.length; i++) {
                    if (!(selected[i] as HTMLInputElement).disabled && !(selected[i] as HTMLInputElement).checked) {
                        const item = this._assigmentsGridRef.getGridRef()
                            .dataItem(selected[i].parentElement.parentElement)
                        if ((item as any).SameResourceOrGroup)
                            selected[i].click();
                    }
                }
            }
        }
    }

    renderIfLoaded = () => {
        if (!this.state.dataLoaded)
            return null;

        let title = [];

        if (this.props.groupings.length == 1 && this.props.groupings[0] == -1) {
            title.push(Helper.getTranslation("WebSMS.ResourcePlaningGrouping.MoveProject") + ' - ' +
                this.props.projNr + ' / ' + this.props.pIndex);
        } else {
            //1. main assignment 
            const text = this.props.resizeAction ?
                Helper.getTranslation("WebSMS.ResourcePlaningGrouping.ResizeAssignments") :
                Helper.getTranslation("WebSMS.ResourcePlaningGrouping.MoveAssignments");
            title.push(text + ': ' + this.props.projNr + ' / ' + this.props.pIndex);
        }

        const ModalDialgProps: DialogProps = {
            title: title.join('; '),
            actions: this.GetAssignmentGroupingDialogActions(),
            modalCancelTimeout: 5 * 60,
            afterClose: () => {
            },
            width: "90%",
            open: true,
            isFlex: true
        }

        const gridButtons: Array<GridCustomToolBarButton> = [
            {
                autoEnabledOnRecordSelected: false,
                caption: Helper.getTranslation("WebSMS.Database.Migration.ReportMigration.SelectAll"),
                enabled: true,
                iconClass: "k-i-checkbox-checked",
                id: "selectAll"
            },
            {
                autoEnabledOnRecordSelected: false,
                caption: Helper.getTranslation("WebSMS.Database.Migration.ReportMigration.DeselectAll"),
                enabled: true,
                iconClass: "k-i-checkbox",
                id: "unSelectAll"
            },
            {
                autoEnabledOnRecordSelected: false,
                caption: Helper.getTranslation("WebSMS.UserSettings.SameResourceOrGroupAssignments"),
                enabled: true,
                iconClass: "k-i-checkbox-checked",
                id: "selectSameResourceOrGroup"
            }
        ];

        return <Dialog {...ModalDialgProps} >
            <Grid
                ref={(r) => this._assigmentsGridRef = r}
                styleContainer={{ "height": "auto" }}
                id="ResourcePlanningGroupingDialogGrid"
                options={this._assigmentsGridOptions}
                throttleActive={false}
                data={this._assigmentsData}
                customButtons={gridButtons}
                onClickCustomButton={this.onCustomButtonClick}
                onDataBound={(e) => {
                    $(e.sender.wrapper).on("click", ".checkboxTable", (ev) => {

                        const $target = $(ev.target);
                        const checked = $target.is(":checked");

                        const dataItem = e.sender.dataItem($target.closest("tr"));
                        const isGuid = dataItem.IsGuid;

                        if (Helper.hasValue(dataItem)) {
                            const idx = this.IsGuids.indexOf(isGuid);

                            if (checked) {
                                if (idx == -1)
                                    this.IsGuids.push(isGuid);
                            } else {
                                if (idx > -1)
                                    this.IsGuids.splice(idx, 1);
                            }
                        }
                    });
                }
                }>
            </Grid>
        </Dialog>
    }

    render() {
        return this.renderIfLoaded();
    }
}

export interface EinsatzViewModelWithGruppirungStatus {
    projNr: string;
    pIndex: number;
    mehrfachbelegung: boolean;
    datensatzsperre: boolean;
    belege: boolean;
    recht: boolean;
    fixiert: boolean;
    actionLock: boolean;
    selected: boolean;
    resizeFehler: boolean;
    newStartIst: string;
    newEndeIst: string;
    startIst: string;
    endeIst: string;
    recordRight: {
        CanRead: true, CanWrite: true
    };
    isId: number;
    isGuid: string;
    ressNr: string;
    ressName: string;
    adrNr: string;
    adresseText: string;
    bemerkung: string;
    kennwort: string;
    grNr: number;
    gruppeName: string;
    fertig: number;
    newRessNr: string;
    newRessName: string;
    newGrNr: number;
    newGruppeName: string;
    changedV: boolean;
    changedH: boolean;
    unselect: boolean;
    resizeAction: boolean;
}

export interface ResourcePlanningGroupingProps extends AppBaseProps {
    context: Context;
    entity: ResourcePlanningGroupingEntity;
}

export interface ResourcePlanningGroupingEntity extends Entity {
    projNr: string;
    pIndex: number;
    title: string;
    grouping: number;
}